export const PAGES = '[Pages]';
export const PUSULA_API_KEY = '92530B0F-E9EB-4B9E-9BE5-D1F3362406C3';
